import { BrushOutlineIcon } from './BrushOutlineIcon';

/**
 * author: Google
 * id 0C2A4D14-A68C-444C-B01C-70CBD6DE0A69
 * name brush-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/brush-outline.svg
 * tags
 * - Drawing / Art 
 */
export const PaintbrushOutlineIcon = BrushOutlineIcon;
export default PaintbrushOutlineIcon